// import
// To be changed
// import Tables from "views/Dashboard/Tables.js";
import {
  CartIcon,
  DocumentIcon,
  HomeIcon,
  PersonIcon,
  StatsIcon,
  RocketIcon,
  InvisionLogo,
  DashboardLogo,
} from "components/Icons/Icons";
import Calendar from "views/Applications/Calendar";
import DataTables from "views/Applications/DataTables";
import Kanban from "views/Applications/Kanban.js";
import Wizard from "views/Applications/Wizard.js";
import SignInBasic from "views/Authentication/SignIn/SignInBasic.js";
import SignInCover from "views/Authentication/SignIn/SignInCover.js";
import SignInIllustration from "views/Authentication/SignIn/SignInIllustration.js";
import LockBasic from "views/Authentication/Lock/LockBasic.js";
import LockCover from "views/Authentication/Lock/LockCover.js";
import LockIllustration from "views/Authentication/Lock/LockIllustration.js";
import ResetBasic from "views/Authentication/Reset/ResetBasic.js";
import ResetCover from "views/Authentication/Reset/ResetCover.js";
import ResetIllustration from "views/Authentication/Reset/ResetIllustration.js";
import VerificationBasic from "views/Authentication/Verification/VerificationBasic.js";
import VerificationCover from "views/Authentication/Verification/VerificationCover.js";
import VerificationIllustration from "views/Authentication/Verification/VerificationIllustration.js";
import SignUpBasic from "views/Authentication/SignUp/SignUpBasic.js";
import SignUpCover from "views/Authentication/SignUp/SignUpCover.js";
import SignUpIllustration from "views/Authentication/SignUp/SignUpIllustration.js";
import Automotive from "views/Dashboard/Automotive";
import CRM from "views/Dashboard/CRM.js";
import Default from "views/Dashboard/Default.js";
import Landing from "views/Dashboard/Landing.js";
import OrderDetails from "views/Ecommerce/Orders/OrderDetails";
import OrderList from "views/Ecommerce/Orders/OrderList";
import EditProduct from "views/Ecommerce/Products/EditProduct";
import NewProduct from "views/Ecommerce/Products/NewProduct";
import ProductPage from "views/Ecommerce/Products/ProductPage";
import Billing from "views/Pages/Account/Billing.js";
import Invoice from "views/Pages/Account/Invoice.js";
import Settings from "views/Pages/Account/Settings.js";
import Alerts from "views/Pages/Alerts";
import Charts from "views/Pages/Charts.js";
import Pricing from "views/Pages/Pricing.js";
import Overview from "views/Pages/Profile/Overview.js";
import Projects from "views/Pages/Profile/Projects.js";
import Teams from "views/Pages/Profile/Teams.js";
import General from "views/Pages/Projects/General.js";
import Timeline from "views/Pages/Projects/Timeline.js";
import RTLPage from "views/Pages/RTLPage.js";
import NewUser from "views/Pages/Users/NewUser.js";
import Reports from "views/Pages/Users/Reports.js";
import Widgets from "views/Pages/Widgets.js";
import SmartHome from "views/Dashboard/SmartHome";
import Signatures from "views/Applications/Signatures";
import UploadDocument from "views/Applications/UploadDocument";
import SignatureRequests from "views/Applications/SignatureRequests";
import Create from "views/Dashboard/Create";
import Home from "views/Home";
import SignIn from "views/SignIn";
import AddSigner from "views/Applications/AddSigner";
import Generate from "views/Applications/Generate";
import { GlobeIcon } from "components/Icons/Icons";
const dashRoutes = [
  {
    name: "Home",
    path: "/",
    component: Home,
    layout: "/landing",
    icon: <HomeIcon color="inherit" />,
    collapse: false,
    items: [],
    hide: true,
  },
  {
    name: "Sign In",
    path: "/sign-in",
    component: SignIn,
    layout: "/auth",
    icon: <PersonIcon color="inherit" />,
    authIcon: <StatsIcon color="inherit" />,
    collapse: false,
    items: [],
    hide: true,
  },
  {
    name: "Dashboard",
    path: "/dashboard",
    component: UploadDocument,
    layout: "/admin",
    icon: <HomeIcon color="inherit" />,
    collapse: false,
    items: [],
    hide: false,
  },
  {
    name: "Signature",
    path: "/signature",
    component: SignatureRequests,
    layout: "/admin",
    icon: <DocumentIcon color="inherit" />,
    collapse: false,
    items: [],
    hide: false,
  },
  {
    name: "Signatures",
    path: "/signatures",
    component: Signatures,
    layout: "/admin",
    icon: <RocketIcon color="inherit" />,
    collapse: false,
    items: [],
    hide: false,
  },
  {
    name: "Add Signer",
    path: "/add-signer",
    component: AddSigner,
    layout: "/admin",
    icon: <StatsIcon color="inherit" />,
    collapse: false,
    items: [],
    hide: true,
  },
  {
    name: "Generate",
    path: "/generate",
    component: Generate,
    layout: "/admin",
    icon: <StatsIcon color="inherit" />,
    collapse: false,
    items: [],
    hide: true,
  },
];
export default dashRoutes;
